<template>
  <div v-if="uiMode === 'phone_only'">
    <slot />
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: mapState({
    uiMode: state => state.uiMode
  })
}
</script>
